import { render, staticRenderFns } from "./GCheckButton.vue?vue&type=template&id=38225da1&scoped=true&"
import script from "./GCheckButton.vue?vue&type=script&lang=ts&"
export * from "./GCheckButton.vue?vue&type=script&lang=ts&"
import style0 from "./GCheckButton.vue?vue&type=style&index=0&id=38225da1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38225da1",
  null
  
)

export default component.exports